<div class="c-status-bar__bg" [style.width.%]="bgWidth" [style.background]="color"
     [style.opacity]="color ? 0.4 : 1"></div>
<span><ng-content></ng-content></span>
